<template>
    <div class="tab-info td-fc td-fcc">
        <div class="setting">
            <div class="title">当前设置对象</div>
            <div style="margin: 20px;font-size: 14px;">{{studentInfo.name || studentInfo.emp_no}}</div>
            <div class="title">基本设置</div>
            <el-form :model="formModel" :rules="rules" ref="ruleForm" class="demo-ruleForm" size="small">
                <el-form-item label="自动播放右脑记忆辅助音频" prop="auto_voice">
                    <el-radio-group v-model="formModel.auto_voice">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="显示单词识别倒计时" prop="dis_count_down">
                    <el-radio-group v-model="formModel.dis_count_down">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="是否需要逆向记忆" prop="auto_review">
                    <el-radio-group v-model="formModel.reverse_memory">
                        <el-radio :label="1">是</el-radio>
                        <el-radio :label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="单词基础每组单词个数" prop="word_limit">
                    <el-select v-model="formModel.word_limit" placeholder="请选择">
                        <el-option label="5" :value="1"></el-option>
                        <el-option label="10" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="语法基础每组单词个数" prop="grammar_limit">
                    <el-select v-model="formModel.grammar_limit" placeholder="请选择">
                        <el-option label="5" :value="1"></el-option>
                        <el-option label="10" :value="2"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="td-fcc" style="width: 100%;padding-top: 40px;">
                <el-button style="width: 120px;" type="success" @click="submitForm('ruleForm')">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { StudentInfo, StudentSetting, SaveStudentSetting } from '@/api/teacher'
import Lockr from 'lockr'
export default {
    name: "studySetting",
    computed: {

    },
    data() {
        return {
            studentInfo: {}, // 学生信息
            formModel: {
                // auto_review: 1,
                auto_voice: 1,
                dis_count_down: 1,
                word_limit: 1,
                grammar_limit: 1,
                reverse_memory:1,
            },
            rules: {
                // auto_review: [
                //     { required: true, message: '设置项填写不完整，请检查后提交', trigger: 'change' }
                // ],
                auto_voice: [
                    { required: true, message: '设置项填写不完整，请检查后提交', trigger: 'change' }
                ],
                dis_count_down: [
                    { required: true, message: '设置项填写不完整，请检查后提交', trigger: 'change' }
                ],
                word_limit: [
                    { required: true, message: '设置项填写不完整，请检查后提交', trigger: 'change' }
                ],
                grammar_limit: [
                    { required: true, message: '设置项填写不完整，请检查后提交', trigger: 'change' }
                ],
            }
        };
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.SaveSetting()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        async getStudentInfo() {
            let params = {
                token: Lockr.get("teacherToken"),
                student_id: this.$route.query.student_id
            };
            let result = await StudentInfo(params);
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.studentInfo = result.data;
            }
        },
        async getStudentSetting() {
            let params = {
                token: Lockr.get("teacherToken"),
                student_id: this.$route.query.student_id
            };
            let result = await StudentSetting(params);
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                // this.formModel.auto_review = parseInt(result.data.auto_review)
                this.formModel.auto_voice = parseInt(result.data.auto_voice)
                this.formModel.dis_count_down = parseInt(result.data.dis_count_down)
                this.formModel.word_limit = parseInt(result.data.word_limit)
                this.formModel.grammar_limit = parseInt(result.data.grammar_limit)
                this.formModel.reverse_memory = parseInt(result.data.reverse_memory)
            }
        },
        async SaveSetting() {
            let params = {
                ...this.formModel,
                token: Lockr.get("teacherToken"),
                student_id: this.$route.query.student_id
            };
            let result = await SaveStudentSetting(params);
            if (result.code === this.GLOBAL.Serve.SUCCESS_CODE) {
                this.getStudentSetting()
                this.$message({
                    message: result.msg,
                    type: "success",
                });
            } else {
                this.$message({
                    message: result.msg,
                    type: "warning",
                });
            }
        },
    },
    created() {
        this.getStudentInfo();
        this.getStudentSetting()
    },
    beforeCreate() {
        document.querySelector("body").setAttribute("style", "background-color:#fff");
    }
}
</script>

<style scoped lang='less'>
.tab-info {
    padding: 40px 0;
    background: #fff;
    border: 1px solid #dcdcdc;
    .setting {
        width: 600px;
        margin: 20px auto;
        .el-form {
            padding: 20px;
        }
        .el-form-item {
            width: 50%;
            display: flex;
            flex-direction: column;
            float: left;
            /deep/ .el-form-item__label {
                text-align: left;
            }
        }
    }
    .title {
        font-size: 18px;
        font-weight: bold;
    }
    .set-line {
        display: flex;
        align-items: center;
        .set-item {
            padding: 10px;
            font-size: 16px;
            width: 300px;
            >div {
                margin: 10px 0;
            }
        }
    }
}
</style>